module.exports = __webpack_public_path__ + "img/monkey_king_alt1.d918ab5d.png";